// extracted by mini-css-extract-plugin
export var text = "separator-with-text-module--text--WGez8";
export var wrapper = "separator-with-text-module--wrapper--guAmM";